import React from "react";
import { Modal, Input, Form, Tag, ColorPicker } from "antd";
import {
  MODALITY_LABEL,
  getModalityFromKey,
  getSubLabelFromKey,
} from "../utils/annotationKey";

const PendingAnnotationModal = ({
  open,
  pendingAnnotationData,
  newAnnotationName,
  setNewAnnotationName,
  newAnnotationDesc,
  setNewAnnotationDesc,
  newAnnotationColor,
  setNewAnnotationColor,
  onSave,
  onCancel,
}) => {
  const annotationKey = pendingAnnotationData?.annotationKey;
  const modality = getModalityFromKey(annotationKey);
  const subLabel = getSubLabelFromKey(annotationKey);

  return (
    <Modal
      title="Nouvelle annotation"
      open={open}
      onOk={onSave}
      okText="Enregistrer"
      okButtonProps={{ disabled: !newAnnotationName }}
      cancelText="Annuler"
      onCancel={onCancel}
      destroyOnClose
      width={460}
    >
      {modality && (
        <div style={{ marginBottom: 12 }}>
          <Tag color="blue">{MODALITY_LABEL[modality]}</Tag>
          {subLabel && (
            <span style={{ color: "var(--color-text-secondary)" }}>
              {subLabel}
            </span>
          )}
        </div>
      )}
      <Form layout="vertical">
        <Form.Item label="Nom" required>
          <Input
            placeholder="Nom de l'annotation"
            value={newAnnotationName}
            onChange={(e) => setNewAnnotationName(e.target.value)}
            autoFocus
          />
        </Form.Item>
        <Form.Item label="Description">
          <Input.TextArea
            placeholder="Description (optionnelle)"
            value={newAnnotationDesc}
            onChange={(e) => setNewAnnotationDesc(e.target.value)}
            rows={3}
          />
        </Form.Item>
        <Form.Item label="Couleur">
          <ColorPicker
            value={newAnnotationColor || undefined}
            onChange={(c) => setNewAnnotationColor?.(c.toRgbString())}
            showText
            disabledAlpha
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PendingAnnotationModal;
